import styled from 'styled-components';
import React from 'react';
import { TextButton } from '../common/TextButton';

type Props = {
  isKor: boolean;
  isSend: boolean;
  onSendEmail: () => void;
  onVerify: () => void;
};

export const EmailVerificationButton = ({
  isKor,
  isSend,
  onSendEmail,
  onVerify,
}: Props) => {
  return (
    <>
      {isSend ? (
        <ButtonWrapper>
          <TextButton
            title={isKor ? '재전송하기' : 'Re-Send'}
            onClick={onSendEmail}
            color='#3A3B3E'
            bgColor='#F5F6F7'
            style={{ minWidth: '110px', maxWidth: '110px' }}
            fontSize='16px'
          />
          <TextButton
            title={isKor ? '인증하기' : 'Verify'}
            onClick={onVerify}
            color='#fff'
          />
        </ButtonWrapper>
      ) : (
        <TextButton
          title={isKor ? '인증 메일 발송하기' : 'Send Verification mail'}
          onClick={onSendEmail}
          color='#246CF6'
          bgColor='#fff'
          style={{ border: '1px solid #246CF6' }}
        />
      )}
    </>
  );
};

const ButtonWrapper = styled.div`
  display: flex;
  gap: 8px;
  width: 100%;
`;
